import { createFileRoute } from "@tanstack/react-router";
import { ChangelogPage } from "@/components/blog/ChangelogPage";
import { head, loader } from "@/lib/changelog-route";

export const Route = createFileRoute("/$locale/changelog")({
  loader,
  head,
  component: function ChangelogLocaleRoute() {
    return <ChangelogPage posts={Route.useLoaderData().posts} />;
  },
});
